import React from 'react';

import Avatar from './Avatar';

export default function Testimonial({ testimonial, isLarge }) {
  const style = `testimonial ${isLarge ? '--large' : ''}`;

  const TestimonialAuthorFullName = () => (
    <p className="body">
      <span className="body --small --emphasized --bold">
        {testimonial.userName}
        {', '}
      </span>
      <span className="body --small --shadow-light">
        {testimonial.userTitle}
      </span>
    </p>
  );

  return (
    <>
      {testimonial && (
        <div className={style}>
          <div className="testimonial__quote">
            <p className="body">
              {'"'}
              {testimonial.quote.quote}
              {'"'}
            </p>
            {isLarge && <TestimonialAuthorFullName />}
          </div>
          <div className="testimonial__info">
            <Avatar avatar={testimonial.avatar} isLarge={isLarge} />
            {!isLarge && (
              <div className="testimonial__author">
                <>
                  <p className="body --shadow-light --upper">
                    {testimonial.userCompany}
                  </p>
                  <TestimonialAuthorFullName />
                </>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
